import React, { useEffect } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { Grid, Box, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import '../../assets/style/fck_editorarea.css'

const useStyles = makeStyles((theme: Theme) => ({
  hiddenInput: {
    display: 'none'
  }
}))
const headline = { display: 'inline-block', width: '120px', margin: '0 10px 10px 0' }

const TinyMCE: React.FC<{
  initialValue?: string
  inputHandler?: (tinyMCEContent: string) => void
  editorRef: React.MutableRefObject<any>
}> = ({ initialValue, inputHandler, editorRef }) => {
  const classes = useStyles({})
  const inputRef = React.useRef(null)
  const [editorKey, setEditorKey] = React.useState(0)

  useEffect(() => {
    if (initialValue === '') clearEditor()
  }, [initialValue])

  const clearEditor = () => {
    const newKey = editorKey + 1
    setEditorKey(newKey)
  }
  const fileInputHandler = callback => {
    const handleFiles = function () {
      var file = this.files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        const target = e.target as any
        callback(target.result, {
          alt: ''
        })
      }
      reader.readAsDataURL(file)
    }
    inputRef.current.addEventListener('change', handleFiles, false)
    inputRef.current.click()
  }

  const tinyMceConfig = {
    paste_data_images: true,
    visual: false,
    content_css: [
      '/style/preview.css',
      '/style/fck_editorarea.css',
      '//fonts.googleapis.com/css?family=Roboto|Kosugi|Kosugi+Maru|M+PLUS+1p|M+PLUS+Rounded+1c|Noto+Sans+JP|Noto+Serif+JP|Sawarabi+Gothic|Sawarabi+Mincho&display=swap'
    ],
    language: 'ja',
    language_url: '/languages/ja.js',
    style_formats: [
      {
        title: 'カスタム',
        items: [
          {
            title: 'Headline1',
            block: 'div',
            classes: 'fck_h2'
          },
          {
            title: 'Headline2',
            block: 'div',
            classes: 'fck_h3'
          },
          {
            title: 'Headline3',
            block: 'div',
            classes: 'fck_h4'
          },
          {
            title: 'Headline4',
            block: 'div',
            classes: 'fck_h5'
          },
          {
            title: 'Headline5',
            block: 'div',
            classes: 'fck_h6'
          },
          {
            title: 'box',
            block: 'div',
            classes: 'fck_box'
          },
          {
            title: 'shadowbox',
            block: 'div',
            classes: 'fck_shadowbox'
          },
          {
            title: 'dotbox',
            block: 'div',
            classes: 'fck_dotbox'
          }
        ]
      }
    ],
    style_formats_merge: true,
    plugins: [
      // Advanced List plugin
      // 数値形式と箇条書き形式のリスト表示機能をさらに拡張する
      'advlist',
      // エディターの大きさを自動で調整
      'autoresize',
      // キーボードからは入力できない特殊記号を挿入可能にする
      'charmap',
      // 生HTMLを編集
      'code',
      // 画像を挿入可能にする
      'image',
      // 現在時刻を様々なフォーマットで挿入可能にする
      'insertdatetime',
      // リスト表示機能を追加する
      'lists',
      // リンクを追加可能にする
      'link',
      // &nbsp(一文字空白)を追加
      'nonbreaking',
      // Microsoft Wordから貼り付けられたコンテンツをきちんと表示される
      // ようにパースする
      'paste',
      // 文字を検索、痴漢する機能を追加する
      'searchreplace',
      // Viewタブからブロック要素を表示可能にする
      'visualblocks',
      // Viewタブから目に見えない空白要素などを表示可能にする
      'visualchars',
      // 表挿入
      'table'
    ],
    menubar: 'edit view insert format tools',
    font_formats: `
      Robot=Robot;
      Times New Roman=times new roman;
      Akzidenz Grotesk=Akzidenz-Grotesk;
      DIN=din;
      Noto Sans JP 日本語フォント=Noto Sans JP;
      Noto Serif JP 日本語フォント=Noto Serif JP;
      M PLUS 1p 日本語フォント=M PLUS 1p;
      M PLUS Rounded 1c 日本語フォント=M PLUS Rounded 1c;
      さわらび明朝=Sawarabi Mincho;
      さわらびゴシック=Sawarabi Gothic;
      小杉ゴシック =Kosugi;
      小杉丸ゴシック=Kosugi Maru;`,
    toolbar1: `
      undo redo | 
      styleselect | 
      bold italic nonbreaking | 
      alignleft aligncenter alignright alignjustify | 
      bullist numlist outdent indent code |
      table 
      `,
    toolbar2: `link image | forecolor backcolor`,
    file_picker_callback: (callback, value, meta) => {
      if (meta.filetype === 'image') {
        fileInputHandler(callback)
      }
    },
    relative_urls: false,
    target_list: false
  }

  return (
    <React.Fragment>
      <Box mb={3}>
        <Typography variant="body2" paragraph>
          段落のカスタムスタイル
        </Typography>
        <Box>
          <div>
            <Box className="fck_h2" style={headline}>
              Headline1
            </Box>
            <Box className="fck_h3" style={headline}>
              Headline2
            </Box>
            <Box className="fck_h4" style={headline}>
              Headline3
            </Box>
            <Box className="fck_h5" style={headline}>
              Headline4
            </Box>
            <Box className="fck_h6" style={headline}>
              Headline5
            </Box>
            <Box className="fck_box" style={headline}>
              box
            </Box>
            <Box className="fck_shadowbox" style={headline}>
              shadowbox
            </Box>
            <Box className="fck_dotbox" style={headline}>
              dotbox
            </Box>
          </div>
        </Box>
      </Box>
      <Editor
        key={editorKey}
        apiKey="u7r6g01u2sce2akb56v62gi4sne720u40h1rq7qsws3o494k"
        ref={editorRef}
        initialValue={initialValue}
        init={tinyMceConfig}
        onChange={event => inputHandler(event.target.getContent() as string)}
      />
      <input ref={inputRef} type="file" className={classes.hiddenInput} />
    </React.Fragment>
  )
}

export default TinyMCE
